import {
  BoletoPaymentResponse,
  CheckPaymentResponse,
  CreditCardPaymentResponse,
  FaturaCotacao,
  PixPaymentResponse,
} from "@/types/Payment";
import api from "./api";
import apiHmlg from "./apiHmlg";

const API_TARGET = import.meta.env.VITE_API_TARGET || "prod";

const ApiAmbient = API_TARGET.toLowerCase() === "hmlg" ? apiHmlg : api;

export const payWithPixAPI = async (body: {
  cotacao_codigo: number;
  cpf: string;
  nome: string;
  email: string;
  telefone: string;
  endereco: string;
  numero_endereco: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
  cep: string;
  mun_codigo: string;
}): Promise<PixPaymentResponse> => {
  const response = await ApiAmbient.post("/iugu/pagamento-pix.php", body);
  return response.data;
};

export const payWithBoletoAPI = async (body: {
  cotacao_codigo: number;
  cpf: string;
  nome: string;
  email: string;
  telefone: string;
  endereco: string;
  numero_endereco: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
  cep: string;
  mun_codigo: string;
}): Promise<BoletoPaymentResponse> => {
  const response = await ApiAmbient.post("/iugu/pagamento-boleto.php", body);
  return response.data;
};

export const payWithCreditCardAPI = async (body: {
  cotacao_codigo: number;
  cpf: string;
  nome: string;
  sobrenome: string;
  email: string;
  telefone: string;
  numero: string; // card number
  cvv: string;
  mes: string;
  ano: string;
  parcelas: number;
  endereco: string;
  numero_endereco: string; // address number
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
  cep: string;
  mun_codigo: string;
}): Promise<CreditCardPaymentResponse> => {
  const response = await ApiAmbient.post("/iugu/pagamento-cartao.php", body);
  return response.data;
};

export const checkPaymentStatusAPI = async (
  invoice_id: string,
): Promise<CheckPaymentResponse> => {
  const response = await ApiAmbient.post("/iugu/verifica-pagamento.php", {
    invoice_id,
  });
  return response.data;
};

export const getFaturasCotacao = async (
  cve_codigo: string,
): Promise<FaturaCotacao[]> => {
  const response = await ApiAmbient.post<FaturaCotacao[]>(
    "/ecom/api_cotacao_faturas.php",
    { cve_codigo },
  );
  return response.data;
};
